module.exports = __webpack_public_path__ + "img/op_img-header.450b1e2.png";